import { observer } from 'mobx-react';
import Modal from './Modal';
export type { ModalProps, ModalPlacement } from './Modal';
export { MODAL_CROSS_CLASSES } from './Modal';

export default observer(Modal);
